// SPDX-License-Identifier: AGPL-3.0-or-later

export function areVoiceBackgroundsAvailable(): boolean {
	return false;
}
